import {Pipe, PipeTransform} from "@angular/core";
import {AuditType} from "../../store/state/order.state";
import {TranslateService} from "@ngx-translate/core";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {Translations} from "../translations/translations.model";

@Pipe({
    name: 'auditType',
    standalone: false
})
export class AuditTypePipe implements PipeTransform {

	constructor(private translateService: TranslateService) {
	}

	transform(type: AuditType, displaySurveillanceNumber: boolean = true): Observable<string> {
		let translations$: Observable<Translations> = this.translateService.get('pricing-details.audit-type');

		return translations$.pipe(map(translations => {
			const auditType = translations[type];

			if ([AuditType.SURVEILLANCE_1, AuditType.SURVEILLANCE_2].includes(type) && !displaySurveillanceNumber) {
				return auditType.substring(0, auditType.length - 2);
			}

			return auditType;
		}));
	}
}
